function splitTitleByHighlights(title = "", highlighted_words = []) {
    // Escaper les mots à surligner pour éviter les caractères spéciaux en regex
    const escapedWords = highlighted_words.map(word => word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));

    // Créer une expression régulière pour trouver tous les mots à surligner
    const regex = new RegExp(`(${escapedWords.join('|')})`, 'gi');

    // Split le titre selon les mots surlignés
    const parts = title.split(regex);

    // Créer un tableau d'objets avec la chaîne et si elle est surlignée ou non
    return parts.map(part => ({
        text: part,
        isHighlighted: highlighted_words.some(word => word.toLowerCase() === part.toLowerCase())
    }));
}

export default function Heading(
    {
        title = "",
        highlighted_words = [],
        subtitle = ""
    }
) {
    const split_title = splitTitleByHighlights(title,highlighted_words);

    return (
        <div className="w-full flex flex-col items-center text-center text-balance gap-[1.5rem] mx-auto mb-[3.125rem]">
            <h1 className="text-heading-1 mobile:text-heading-2 font-[800] leading-[100%]">
                {split_title.map(v=>
                    <>
                    {v.isHighlighted ? <span className="text-zoeil-blue">
                        {v.text}
                    </span>
                    :
                    <span>
                        {v.text}
                    </span>}
                    </>
                )}
            </h1>
            <p className="text-balance">
                {subtitle}
            </p>
        </div>
    )
}